import { ErrorSidePanel } from '@/components/errors';
import { getMobilePlatform, loadHistoryState } from '@/lib';
import {
  ErrorCodes,
  ModuleName,
  Screen,
  type SkinPageConfig,
  templates,
} from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { mfaSetupFlowSchema } from '../../../-model/flow';
import { type RegisterProps } from './-model/props';
import { RegisterLight } from './-skins';

export const Route = createFileRoute('/(security)/security/_mfa-setup/authenticator-app/register/')(
  {
    component: RouteComponent,
    errorComponent: ErrorSidePanel,
    staticData: {
      module: ModuleName.Security,
      screen: Screen.StandarSetup,
      setupStep: { number: 2 },
    },
    loader: loadHistoryState(mfaSetupFlowSchema, { errorCode: ErrorCodes.AccessDenied }),
  },
);

function RouteComponent() {
  const setup = Route.useLoaderData();
  const navigate = Route.useNavigate();
  const [confirmed, setConfirmed] = useState(false);

  const props: RegisterProps = {
    uri: setup.Uri,
    secret: setup.Secret,
    platform: getMobilePlatform(),
    googleSelected: setup.SelectedApp === 'google',
    confirmed,
    setConfirmed,
    goToValidate: () => {
      navigate({ to: '/security/authenticator-app/validate', state: setup });
    },
  };

  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: RegisterProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <RegisterLight {...props} />,
  };
}
